import React, { createContext, useContext } from 'react';
import useResolvedNav from '../hooks/useResolvedNav';

/*
 * canOpen(path) for links rendered deep in the tree (Help Center guides,
 * assistant answers) — one nav resolution for the whole app instead of one
 * per link. Without a provider every path is allowed and the route guards
 * decide, as before.
 */
const NavAccessContext = createContext(() => ({ allowed: true }));

export function NavAccessProvider({ children }) {
  const { canOpen } = useResolvedNav();
  return <NavAccessContext.Provider value={canOpen}>{children}</NavAccessContext.Provider>;
}

export const useCanOpen = () => useContext(NavAccessContext);
